import { TableBorderRadiusEnum } from "../types";

const MAP: Record<TableBorderRadiusEnum, number> = {
  [TableBorderRadiusEnum.None]: 0,
  [TableBorderRadiusEnum.Small]: 4,
  [TableBorderRadiusEnum.Medium]: 8,
  [TableBorderRadiusEnum.Large]: 12,
};

export const getTableBorderRadiusValue = (value: TableBorderRadiusEnum) => {
  return MAP[value] ?? MAP[TableBorderRadiusEnum.Small];
};
